/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconNotificationOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconNotificationOn"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="m13 2 .001 2.071A7 7 0 0 1 19 11v6h2v2h-5.126a4.002 4.002 0 0 1-7.748 0H3v-2h2v-6a7 7 0 0 1 6-6.93V2zm.732 17h-3.464a2 2 0 0 0 3.464 0M12 6a5 5 0 0 0-5 5v6h10v-6a5 5 0 0 0-5-5m5.645-4.443a11.1 11.1 0 0 1 3.2 2.903A10.95 10.95 0 0 1 23 11h-2a8.95 8.95 0 0 0-1.762-5.35 9.1 9.1 0 0 0-2.62-2.377zm-11.29 0 1.027 1.716a9.1 9.1 0 0 0-2.62 2.377A8.95 8.95 0 0 0 3 11H1c0-2.387.764-4.662 2.155-6.54a11.1 11.1 0 0 1 3.2-2.903"
    />
  </svg>
);
export default IconNotificationOn;
